export const getBookingProduceJoinPreviewPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/production/produce-join-preview`;
export const getBookingBulkArchivePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/bookings/bulk/archive`;
export const getBookingBulkCancelPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/bookings/bulk/cancel`;
export const getBookingBulkClonePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/bookings/bulk/clone`;
